import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { LayoutModule } from "@copec-gid/tema-default-a16/left-light"
import { HttpInterceptorFn, provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppComponent } from './core/inicial-componente/app.component';
import { PageWaitComponent } from './core/inicial-componente/page-wait/page-wait.component';

//MODULO DE SEGURIDAD
import { LIB_CONFIG, SecureStorageService, requestInterceptor } from '@copec-gid/gid-arquitectura.seguridad-autorizacion-modulo';
import { SessionService } from './services/session.service';
import { LIB_CONF } from './core/conf/lib_conf';

import { environment } from 'src/environments/environment';
import { ReactiveFormsModule } from '@angular/forms';
import { CardWrapperComponent } from './core/card-wrapper/card-wrapper.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BootstrapComponent } from './views/pages/bootstrap/bootstrap.component';
import { TooltipComponent } from './core/tooltip/tooltip.component';
import { BlankErrorPageComponent } from './views/pages/blank-error-page/blank-error-page.component';
import { BlankSuccessComponent } from './views/pages/blank-success/blank-success.component';
import { CreateSessionComponent } from './views/pages/create-session/create-session.component';
import { GidLoggerModule, GidLoggerService } from '@copec-gid/gid-arquitectura.console-log';
import { LottieAnimationComponent } from './core/lottie-animation/lottie-animation.component';
import { AnimationPageComponent } from './core/animation-page/animation-page.component';
import { BlankIframeComponent } from './views/blank-iframe/blank-iframe.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { NoAccessModalComponent } from './core/no-access-modal/no-access-modal.component';
import { RedirectTbkComponent } from './views/pages/redirect-tbk/redirect-tbk.component';
import { Globals } from './globals';

// Adaptador para usar el interceptor función en una app de tipo módulo.
export const adapterInterceptorFn: HttpInterceptorFn = (req, next) => {
  return requestInterceptor(req, next);
};

/*
  hydrate( .. ) va acá y no vía provideSecureStorage( .. ): ese helper lo registra
  como otro APP_INITIALIZER y Angular los corre en paralelo, con lo que podría
  resolver después de createNoLoginSession( .. ) y pisar la sesión recién creada.
*/
function initSession(storage: SecureStorageService, sessionService: SessionService) {
  return async () => {
    // Un rechazo acá aborta el bootstrap de Angular (pantalla en blanco y sin log).
    // Se deja arrancar: sin sesión, ConditionalAuthGuard redirige a CreateSessionComponent,
    // que reintenta y, si vuelve a fallar, reporta SESSION_POST y muestra /err.
    try {
      await storage.hydrate();

      const queryParams = new URLSearchParams(window.location.search);
      sessionStorage.setItem('initial_has_status', String(queryParams.has('status')));

      // Con `status` esta instancia es el retorno del iframe 3DS: crear sesión acá
      // pisaría la del padre, porque el storage es compartido por origen.
      if (!queryParams.has('status')) {
        await sessionService.createNoLoginSession();
      }
    } catch (error) {
      console.error('initSession', Globals.sanitizeForLog(error));
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    PageWaitComponent,
    CardWrapperComponent,
    BootstrapComponent,
    TooltipComponent,
    BlankErrorPageComponent,
    BlankSuccessComponent,
    CreateSessionComponent,
    LottieAnimationComponent,
    AnimationPageComponent,
    BlankIframeComponent,
    NoAccessModalComponent,
    RedirectTbkComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    LayoutModule,
    AppRoutingModule,
    ReactiveFormsModule,
    GidLoggerModule.forRoot(environment),
    MatFormFieldModule, MatInputModule, MatToolbarModule,
    MatGridListModule, MatTooltipModule, MatButtonModule,
    MatBottomSheetModule
  ],
  providers: [
    provideHttpClient(withInterceptors([adapterInterceptorFn])),
    { provide: LIB_CONFIG, useValue: LIB_CONF },
    {
      provide: APP_INITIALIZER,
      useFactory: initSession,
      multi: true,
      deps: [SecureStorageService, SessionService]
    },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }
  ],
  bootstrap: [/* AppComponent */BootstrapComponent]
})
export class AppModule {

}
